import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type TabsSeparatorProps = ComponentProps<"span">

/**
 * Splits a tab strip into runs of related tabs — e.g. the catalogs an
 * operator edits vs. the review states they work through. Decoration only:
 * not focusable, and invisible to the tab list's roving focus.
 */
function TabsSeparator(props: TabsSeparatorProps) {
  const { className, ...spanProps } = props

  return (
    <span
      aria-hidden
      className={cn("ui-tabs-separator", className)}
      {...spanProps}
    />
  )
}

export default TabsSeparator
